module.exports = __webpack_public_path__ + "img/pazar-sherkati.59200d79.jpg";